import React from "react";
//#region types
import { IncomingInvoicePaymentStatusProps } from "models/propTypes/incomingInvoicePropTypes";
import { StyleEnums } from "models/enums";
import { WintSuperkollAPIModel as APIModels } from "wint-api-client/dist/types";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import { Icon } from "components/common";
import { Grid, Tooltip } from "@mui/material";
import { useIncomingInvoiceService } from "serviceHooks";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const IncomingInvoicePaymentStatus: React.FC<IncomingInvoicePaymentStatusProps> = (props) => {
  const incomingInvoiceService = useIncomingInvoiceService();
  const getPaymentStatusIcon = (status: APIModels.IncomingInvoicePaymentStatus) => {
    switch (status) {
      case APIModels.IncomingInvoicePaymentStatus.Due:
        return {
          icon: IconDefinitionConstants.WExclamation,
          type: StyleEnums.DisplayType.Danger,
        };
      case APIModels.IncomingInvoicePaymentStatus.DueSoon:
        return {
          icon: IconDefinitionConstants.WExclamation,
          type: StyleEnums.DisplayType.Warning,
        };
      case APIModels.IncomingInvoicePaymentStatus.Paid:
        return {
          icon: IconDefinitionConstants.WValidateCheck,
          type: StyleEnums.DisplayType.Success,
        };
      case APIModels.IncomingInvoicePaymentStatus.PaymentInProcessing:
        return {
          icon: IconDefinitionConstants.WArrowSmallRight,
          type: StyleEnums.DisplayType.None,
        };
      case APIModels.IncomingInvoicePaymentStatus.ManualPayment:
        return {
          icon: IconDefinitionConstants.WArrowSmallRight,
          type: StyleEnums.DisplayType.Info,
        };
      default:
        return {
          icon: IconDefinitionConstants.WEmpty,
          type: StyleEnums.DisplayType.None,
        };
    }
  };

  const paymentValues = getPaymentStatusIcon(props.status);

  return paymentValues ? (
    <Tooltip
      disableInteractive
      placement="top"
      title={incomingInvoiceService.getPaymentStateText(props.status)}
      classes={{ tooltip: cssExports.tooltip, popper: cssExports.tooltipPopper }}
    >
      <Grid item>
        <Icon icon={paymentValues.icon} className={cssExports.tableIcon} displayType={paymentValues.type} />
      </Grid>
    </Tooltip>
  ) : (
    <></>
  );
};

export default IncomingInvoicePaymentStatus;
